import React from "react";
import styled, { keyframes, css } from "styled-components";
const img301 =
  "https://lovecraftgift.com/cdn/shop/files/Asset-31_500x.png?v=1728712246";
const img302 =
  "https://consultationguru.com/wp-content/uploads/2023/01/logo-300x137.png";
const img303 =
  "https://blisswayimmigration.in/wp-content/uploads/2023/11/White-Logo-Landscape.png";
const img304 =
  "https://lovecraftgift.com/cdn/shop/files/Asset-31_500x.png?v=1728712246";
const img305 =
  "https://lovecraftgift.com/cdn/shop/files/Asset-31_500x.png?v=1728712246";
const img306 =
  "https://lovecraftgift.com/cdn/shop/files/Asset-31_500x.png?v=1728712246";

const MarqueePhoto = () => {
  const row1 = [img301, img302, img303, img304, img305, img306];

  const row2 = [];

  return (
    <Wrapper>
      <Heading>Our Sponsors</Heading>
      <Marquee>
        <MarqueeGroup>
          {row1.map((src, index) => (
            <ImageGroup key={index}>
              <Image src={src} alt={`Sponsor ${index + 1}`} />
            </ImageGroup>
          ))}
        </MarqueeGroup>
        <MarqueeGroup>
          {row1.map((src, index) => (
            <ImageGroup key={`duplicate-${index}`}>
              <Image src={src} alt={`Sponsor ${index + 1}`} />
            </ImageGroup>
          ))}
        </MarqueeGroup>
      </Marquee>
      {/* <Heading>Our Previous SPEAKERS</Heading> */}
      <Marquee>
        <MarqueeGroupReverse>
          {row2.map((src, index) => (
            <ImageGroup key={index}>
              <Image src={src} alt={`Speaker ${index + 7}`} />
            </ImageGroup>
          ))}
        </MarqueeGroupReverse>
        <MarqueeGroupReverse>
          {row2.map((src, index) => (
            <ImageGroup key={`duplicate-${index}`}>
              <Image src={src} alt={`Speaker ${index + 7}`} />
            </ImageGroup>
          ))}
        </MarqueeGroupReverse>
      </Marquee>
    </Wrapper>
  );
};

export default MarqueePhoto;

// Styled components
const Wrapper = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 40px 0;
  color: #ffffff;
  background: transparent; /* Ensure transparency */
`;

const Heading = styled.h2`
  font-size: 38px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
  color: rgb(13, 168, 215); /* Updated color */
`;

const Marquee = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  user-select: none;
  mask-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 1) 10%,
    rgba(0, 0, 0, 1) 90%,
    rgba(0, 0, 0, 0)
  );
  position: relative;
`;

const scrollX = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
`;

const common = css`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  white-space: nowrap;
  width: 100%;
  animation: ${scrollX} 30s linear infinite;
`;

const MarqueeGroup = styled.div`
  ${common};
  min-width: max-content; /* Prevents shrinking and ensures images stay within bounds */
`;

const MarqueeGroupReverse = styled.div`
  ${common};
  animation-direction: reverse;
  animation-delay: -3s;
  min-width: max-content; /* Ensures this group has enough space to fit all items */
`;

const ImageGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  padding: 10px;
  flex-grow: 1; /* Makes sure each image group gets space */

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const Image = styled.img`
  width: 180px; /* Default size for larger screens */
  max-width: 200px;
  height: auto;
  object-fit: contain;
  border-radius: 0.5rem;
  aspect-ratio: 3/2;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 10px;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    width: 100px; /* Decrease size on mobile */
    max-width: 120px;
    aspect-ratio: 4/3; /* Make images more compact */
  }
`;
